// extracted by mini-css-extract-plugin
module.exports = {"row":"transaction-table_row__2vXnl","icon":"transaction-table_icon__3rYw7","icon_container":"transaction-table_icon_container__2cFci"};